import React from "react";
import Slider from "react-slick";

export default function HomeCircleLogos({ data }) {

  const settings = {
    dots: false,
    slidesToShow: 6,
    autoplay: true,
    slidesToScroll: 1,
    infinite: true,
    pauseOnHover: true,
    arrows: false,
    autoplaySpeed: 0,
    speed: 8000,
    cssEase: "linear",

    responsive: [

      {
        breakpoint: 1150,
        settings: {
          slidesToShow: 4,
        },
      },

      {
        breakpoint: 992,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        },
      },
    ],
  };

  return (
    <>

      <section className="circle-logos">
        <div className="circle-logos-col">
          <Slider {...settings} className="circle-logos-inners">
            {data.map((item, index) => (
              <div className="circle-logos-img" key={index}>
                <div className="logos-img">
                  <img src={item.img} alt="Circle Logo 1" className="img-responsive" loading="lazy" />
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </section>

    </>
  )
}
